var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"form",staticClass:"v-action-form d-flex justify-center"},[(_vm.formConfig)?_c('form-inner',{key:_vm.action_id,attrs:{"form-style":_vm.formStyle,"fundraiser-initial-form-style":_vm.fundraiserInitialFormStyle}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }